import ArticleCard from '@/components/articles/ArticleCard';
import { PAGE_ROUTES, resolveMarketingUrl } from '@/constants/routeMapper';
import type { BlogCard } from '@/features/blogs/data/types';

import { getBlogImplementedPath } from '../../data/blogRoutes';

const BLOGS_BASE_HREF = PAGE_ROUTES.blogs;

export default function BlogCardItem({
  blog,
  showTopics = false,
}: {
  blog: BlogCard;
  showTopics?: boolean;
}) {
  const href = blog.slug
    ? resolveMarketingUrl(getBlogImplementedPath(blog)) ||
      `${BLOGS_BASE_HREF}/${blog.slug}`
    : BLOGS_BASE_HREF;

  return <ArticleCard article={blog} href={href} showTopics={showTopics} />;
}
